import { InventoryItem } from '../types';
import InventoryCard from './InventoryCard';

interface InventoryGridProps {
  items: InventoryItem[];
  onEdit: (item: InventoryItem) => void;
  onToggleActive: (item: InventoryItem) => void;
}

const InventoryGrid = ({
  items,
  onEdit,
  onToggleActive,
}: InventoryGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 sm:px-7 md:hidden">
      {items.map((item) => (
        <InventoryCard
          key={item.id}
          item={item}
          onEdit={onEdit}
          onToggleActive={onToggleActive}
        />
      ))}
    </div>
  );
};

export default InventoryGrid;